module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "productList"
  }, [_vm._m(0), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "width": "80%",
      "background-color": "#f05634",
      "margin": "1rem auto"
    },
    attrs: {
      "type": "warn"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.32rem"
    },
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_vm._v("域名注册前往电脑PC端操作")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact_top"
  }, [_c('div', {
    staticClass: "nav-links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("服务条款")])], 1)])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_title"
  }, [_c('h4', [_vm._v("阿贝云域名注册")]), _vm._v(" "), _c('p', [_vm._v("查询、注册、解析一站式服务")]), _vm._v(" "), _c('p', [_vm._v("提供几十种域名后缀供您选择，最低9元起")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_bottom clearfix"
  }, [_c('a', {
    staticClass: "logo-bottom",
    attrs: {
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weixin-b"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.32rem"
    },
    attrs: {
      "href": "https://www.abeiyun.com"
    }
  }, [_vm._v("切换电脑版")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_bottom_r"
  }, [_vm._v("\n          ©2018 abeiyun All rights reserved\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-581389f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/domain.vue
// module id = 2AqI
// module chunks = 1